export type SupportedLocale = 'en' | 'fr';

type TranslationMap = Record<string, string>;

export const TRANSLATIONS: Record<SupportedLocale, TranslationMap> = {
  en: {},
  fr: {
    // ----------------------------------------
    // TOPBAR / SHELL
    // ----------------------------------------
    'CC APP BACK OFFICE': 'CC APP BACK OFFICE',
    'Fintech operations console': 'Console operations fintech',
    'Builder promo code applicable': 'Code Promo Batisseur applicable',
    'Maximum allowed DSB': 'DSB maximum autorise',
    'of the sale price before any Builder reduction': 'du prix de vente, avant toute reduction Batisseur',
    'The DSB cannot exceed 30% of the sale price.': 'Le DSB ne peut pas depasser 30 % du prix de vente.',
    'Yes': 'Oui',
    'No': 'Non',
    'Logout': 'Se deconnecter',
    'Language': 'Langue',
    'Switch to light mode': 'Passer en mode clair',
    'Switch to dark mode': 'Passer en mode sombre',
    'Main': 'Principal',
    'Finance': 'Finance',
    'Commerce': 'Commerce',
    'Engagement': 'Engagement',
    'Platform Configuration': 'Configuration plateforme',
    'Partner Directory': 'Annuaire partenaires',
    'Wallet Monitoring': 'Suivi des wallets',
    'Ledger Explorer': 'Explorateur comptable',
    'Commerce Analytics': 'Analytique commerce',
    'Events': 'Evenements',
    'Platform': 'Plateforme',
    'Back Office': 'Back Office',
    'Operations console for multi-country fintech administration.': 'Console d operations pour l administration fintech multi-pays.',

    // ----------------------------------------
    // SIDEBAR NAV
    // ----------------------------------------
    'Configuration Center': 'Centre de configuration',
    'Country Setup': 'Parametrage pays',
    'Overview': 'Vue d ensemble',
    'Readiness Checklist': 'Checklist de readiness',
    'General': 'General',
    'Accounting': 'Comptabilite',
    'Chart of Accounts': 'Plan comptable',
    'Membership': 'Adhesion',
    'MLM & Gains': 'MLM et gains',
    'Financing': 'Financement',
    'Payment / PSP': 'Paiement / PSP',
    'Risk & Guarantee': 'Risque et garantie',
    'Country Users / RBAC': 'Utilisateurs pays / RBAC',
    'Version History': 'Historique des versions',
    'Platform Setup': 'Parametrage plateforme',
    'Global Defaults': 'Parametres globaux',
    'Global MLM Rules': 'Regles MLM globales',
    'Feature Flags': 'Feature flags',
    'System Limits': 'Limites systeme',
    'Subscription Revenue Allocation': 'Repartition des revenus d abonnement',
    'Commission pool (%)': 'Pool commission (%)',
    'Collective guarantee fund (%)': 'Fonds de garantie collective (%)',
    'Platform fee (%)': 'Frais plateforme (%)',
    'Administration (%)': 'Administration (%)',
    'Social fund (%)': 'Fonds social (%)',
    'Allocation total:': 'Total allocation :',
    'Operations': 'Operations',
    'Dashboard': 'Tableau de bord',
    'Partner Reporting': 'Reporting partenaires',
    'Partners': 'Partenaires',
    'Offers': 'Offres',
    'Loan Applications': 'Demandes de pret',
    'Applications': 'Demandes',
    'Partner Users': 'Utilisateurs partenaires',
    'Circles': 'Cercles',
    'Loans': 'Prets',
    'Capital': 'Capital',
    'Treasury': 'Tresorerie',
    'Agents': 'Agents',
    'Notifications': 'Notifications',
    'Countries': 'Pays',
    'Media': 'Media',
    'Audit Logs': 'Logs audit',
    'Admin Accounts': 'Gestion des admins',
    'Engagement Tasks': 'Taches d engagement',

    // ----------------------------------------
    // COMMON
    // ----------------------------------------
    'Status': 'Statut',
    'Action': 'Action',
    'Actions': 'Actions',
    'Cancel': 'Annuler',
    'Back': 'Retour',
    'Back to list': 'Retour a la liste',
    'Back to login': 'Retour a la connexion',
    'Search': 'Rechercher',
    'Apply filters': 'Appliquer les filtres',
    'Apply': 'Appliquer',
    'Session expired': 'Session expiree',
    'Session expired due to inactivity': 'Session expiree pour cause d inactivite',
    'Your session has expired. Please sign in again.': 'Votre session a expire. Veuillez vous reconnecter.',
    'Save changes': 'Enregistrer les modifications',
    'Close': 'Fermer',
    'Edit': 'Modifier',
    'View': 'Voir',
    'Reload': 'Recharger',
    'Country': 'Pays',
    'Currency': 'Devise',
    'Email': 'Email',
    'Password': 'Mot de passe',
    'Role': 'Role',
    'Type': 'Type',
    'Name': 'Nom',
    'Amount': 'Montant',
    'Balance': 'Solde',
    'Description': 'Description',
    'Provider': 'Fournisseur',
    'Created': 'Cree le',
    'Created at': 'Cree le',
    'Updated': 'Mis a jour',
    'Account': 'Compte',
    'Total': 'Total',
    'Available': 'Disponible',
    'Enabled': 'Active',
    'Required': 'Requis',
    'Select country': 'Selectionner un pays',
    'No description provided.': 'Aucune description fournie.',
    'Loading...': 'Chargement...',
    'Loading task definitions...': 'Chargement des definitions de taches...',
    'YES': 'OUI',
    'NO': 'NON',
    'Reward points': 'Points de recompense',
    'Disabled': 'Desactive',
    'All countries': 'Tous les pays',
    'All statuses': 'Tous les statuts',
    'All settlements': 'Tous les reglements',
    'All delivery modes': 'Tous les modes de livraison',
    'All origins': 'Toutes les origines',
    'Active': 'Actif',
    'Inactive': 'Inactif',
    'Pending': 'En attente',
    'Paid': 'Payee',
    'Shipped': 'Expediee',
    'Delivered': 'Livree',
    'Cancelled': 'Annulee',
    'Refunded': 'Remboursee',
    'Pending delivery': 'En attente de livraison',
    'Settled': 'Reglee',
    'Reversed': 'Annulee',
    'Failed': 'Echoue',
    'Digital': 'Numerique',
    'Ship to customer': 'Expedier au client',
    'Pickup CC Office': 'Retrait bureau CC',
    'Store': 'Boutique',
    'Event ticket': 'Ticket evenement',
    'Do you want to': 'Voulez-vous',
    'activate': 'activer',
    'deactivate': 'desactiver',
    'confirm delivery': 'confirmer la livraison',
    'refund': 'rembourser',
    'cancel': 'annuler',
    'Error': 'Erreur',
    'status changed': 'statut modifie',
    'Merchant saved': 'Marchand enregistre',
    'Product saved': 'Produit enregistre',
    'Order updated': 'Commande mise a jour',
    'Product updated': 'Produit mis a jour',
    'Merchant updated': 'Marchand mis a jour',
    'Unable to load merchants.': 'Impossible de charger les marchands.',
    'Unable to save merchant.': 'Impossible d enregistrer le marchand.',
    'Unable to update merchant status.': 'Impossible de mettre a jour le statut du marchand.',
    'Unable to load products.': 'Impossible de charger les produits.',
    'Unable to save product.': 'Impossible d enregistrer le produit.',
    'Unable to update product status.': 'Impossible de mettre a jour le statut du produit.',
    'Unable to upload product image.': 'Impossible de televerser l image du produit.',
    'Image uploaded': 'Image televersee',
    'Product image linked successfully.': 'Image du produit liee avec succes.',
    'Product image': 'Image du produit',
    'Remove image': 'Retirer l image',
    'No image uploaded yet.': 'Aucune image televersee pour le moment.',
    'Unable to load orders.': 'Impossible de charger les commandes.',
    'Unable to load order details.': 'Impossible de charger les details de la commande.',
    'Unable to update order.': 'Impossible de mettre a jour la commande.',
    'All partners': 'Tous les partenaires',
    'All types': 'Tous les types',
    'All locations': 'Tous les lieux',
    'Draft': 'Brouillon',
    'Published': 'Publie',
    'Completed': 'Termine',
    'Physical': 'Physique',
    'Online': 'En ligne',
    'Hybrid': 'Hybride',
    'Total revenue': 'Revenu total',
    'Orders count': 'Nombre de commandes',
    'Merchant payouts': 'Paiements marchands',
    'MLM volume generated': 'Volume MLM genere',
    'Tickets sold': 'Tickets vendus',
    'Attendance rate': 'Taux de presence',
    'Pending orders': 'Commandes en attente',
    'Unable to load events.': 'Impossible de charger les evenements.',
    'Loading failed': 'Chargement echoue',
    'Status updated': 'Statut mis a jour',
    '{{name}} is now {{status}}.': '{{name}} est maintenant {{status}}.',
    'Unable to load partners.': 'Impossible de charger les partenaires.',
    'Unable to update partner status.': 'Impossible de mettre a jour le statut du partenaire.',
    'Offer status updated': 'Statut de l offre mis a jour',
    'Unable to update {{name}}.': 'Impossible de mettre a jour {{name}}.',
    'Offer duplicated': 'Offre dupliquee',
    '{{name}} is ready for review.': '{{name}} est prete pour revision.',
    'Duplication failed': 'Duplication echouee',
    'Unable to duplicate {{name}}.': 'Impossible de dupliquer {{name}}.',
    'Post featured': 'Publication mise en avant',
    '{{title}} is now featured.': '{{title}} est maintenant mise en avant.',
    'Action failed': 'Action echouee',
    'Unable to feature post.': 'Impossible de mettre la publication en avant.',
    'Post unfeatured': 'Publication retiree de la mise en avant',
    '{{title}} removed from featured.': '{{title}} a ete retiree de la mise en avant.',
    'Unable to unfeature post.': 'Impossible de retirer la mise en avant.',
    'Post created': 'Publication creee',
    'The post is now visible in the community feed.': 'La publication est maintenant visible dans le fil communautaire.',
    'Creation failed': 'Creation echouee',
    'Unable to create community post.': 'Impossible de creer la publication communautaire.',
    'Supported products required': 'Produits supportes requis',
    'Select at least one supported product.': 'Selectionnez au moins un produit supporte.',
    'Partner created': 'Partenaire cree',
    '{{name}} has been added.': '{{name}} a ete ajoute.',
    'Unable to create partner.': 'Impossible de creer le partenaire.',
    'Partner updated': 'Partenaire mis a jour',
    '{{name}} has been updated.': '{{name}} a ete mis a jour.',
    'Unable to update partner configuration.': 'Impossible de mettre a jour la configuration du partenaire.',
    'Partner status updated': 'Statut du partenaire mis a jour',
    'Credit': 'Credit',
    'Savings': 'Epargne',
    'Fees': 'Frais',
    'Invalid range': 'Plage invalide',
    'Max amount must be greater than min amount.': 'Le montant maximum doit etre superieur au montant minimum.',
    'Invalid JSON': 'JSON invalide',
    '{{field}} must contain valid JSON.': '{{field}} doit contenir un JSON valide.',
    'Offer created': 'Offre creee',
    '{{name}} has been saved.': '{{name}} a ete enregistree.',
    'Unable to create financing offer.': 'Impossible de creer l offre de financement.',
    'Offer updated': 'Offre mise a jour',
    'Unable to update financing offer.': 'Impossible de mettre a jour l offre de financement.',
    'Partner admin': 'Admin partenaire',
    'Partner analyst': 'Analyste partenaire',
    'Partner reviewer': 'Relecteur partenaire',
    'Partner user created': 'Utilisateur partenaire cree',
    '{{name}} has been assigned to {{partner}}.': '{{name}} a ete assigne a {{partner}}.',
    'Unable to create partner user.': 'Impossible de creer l utilisateur partenaire.',
    'Submitted': 'Soumise',
    'Under review': 'En revue',
    'Approved': 'Approuvee',
    'Rejected': 'Rejetee',
    'Disbursed': 'Decaissee',
    'Repaid': 'Remboursee',
    'Load failed': 'Chargement echoue',
    'Unable to load financing applications.': 'Impossible de charger les demandes de financement.',
    'Search failed': 'Recherche echouee',
    'Unable to load wallet monitoring data.': 'Impossible de charger les donnees de suivi wallet.',
    'Microfinance Institution': 'Institution de microfinance',
    'Investor': 'Investisseur',
    'Fund created': 'Fonds cree',
    '{{name}} has been created.': '{{name}} a ete cree.',
    'Admin Sign In': 'Connexion administrateur',
    'Two-Factor Verification': 'Verification a deux facteurs',
    'Authentication service unavailable': 'Service d authentification indisponible',
    'Authentication failed': 'Authentification echouee',
    'The authentication service is currently unreachable. Please try again shortly.':
      'Le service d authentification est actuellement indisponible. Veuillez reessayer sous peu.',
    'Unable to sign in. Please review your credentials.': 'Impossible de vous connecter. Verifiez vos identifiants.',
    '2FA setup failed': 'Configuration 2FA echouee',
    'Unable to initialize Google Authenticator setup. Please try again.':
      'Impossible d initialiser la configuration Google Authenticator. Veuillez reessayer.',
    'Verification unavailable': 'Verification indisponible',
    'Temporary access token missing. Please sign in again.': 'Le token d acces temporaire est manquant. Veuillez vous reconnecter.',
    'Verification failed': 'Verification echouee',
    'The verification code is invalid or expired.': 'Le code de verification est invalide ou expire.',
    'Invitation accepted': 'Invitation acceptee',
    'Your administrator account is activated. You can sign in now.':
      'Votre compte administrateur est active. Vous pouvez maintenant vous connecter.',

    // ----------------------------------------
    // DASHBOARD
    // ----------------------------------------
    'Key platform indicators for operations teams.': 'Indicateurs cles de la plateforme pour les equipes operations.',
    'Global Defaults, Global MLM Rules, Feature Flags and Subscription Revenue Allocation. Read-only by default.':
      'Parametres globaux, regles MLM globales, feature flags et repartition des revenus d abonnement. Lecture seule par defaut.',
    'Configure a country': 'Configurer un pays',
    'Fix these issues before saving the allocation:': 'Corriger ces points avant d enregistrer la repartition :',
    '{{field}} is required.': '{{field}} est requis.',
    '{{field}} must be a valid number.': '{{field}} doit etre un nombre valide.',
    '{{field}} must be >= 0.': '{{field}} doit etre >= 0.',
    'Allocation total must equal 100%.': 'Le total de repartition doit etre egal a 100%.',

    // ----------------------------------------
    // AUTH - LOGIN
    // ----------------------------------------
    'Fintech Admin Suite': 'Suite Admin Fintech',
    'Secure multi-country operations from a single control room.': 'Operations multi-pays securisees depuis une salle de controle unique.',
    'Monitor users, circles, loans, capital, treasury and compliance workflows across every market.':
      'Suivez utilisateurs, cercles, prets, capital, tresorerie et workflows de conformite sur chaque marche.',
    'Access': 'Acces',
    'Coverage': 'Couverture',
    '12 Countries': '12 Pays',
    'Monitoring': 'Monitoring',
    '24/7': '24/7',
    'Enter your admin credentials to request a temporary access token.':
      'Entrez vos identifiants admin pour obtenir un token d acces temporaire.',
    'Enter the code from your authenticator app to complete sign-in.':
      'Entrez le code de votre appli d authentification pour finaliser la connexion.',
    'Continue to 2FA': 'Continuer vers la 2FA',
    'Preparing your Google Authenticator setup...': 'Preparation de votre configuration Google Authenticator...',
    'Temporary token issued. Use your authenticator app to validate access.':
      'Token temporaire emis. Utilisez votre appli d authentification pour valider l acces.',
    'Google Authenticator setup': 'Configuration Google Authenticator',
    'Scan the QR code or use the manual key below, then enter the 6-digit code.':
      'Scannez le QR code ou utilisez la cle manuelle ci-dessous, puis entrez le code a 6 chiffres.',
    'Manual key': 'Cle manuelle',
    'OTP URI': 'URI OTP',
    '2FA code': 'Code 2FA',
    'Verify': 'Verifier',
    'Invited admin?': 'Admin invite ?',
    'Activate your account': 'Activez votre compte',
    'Mock Profiles': 'Profils de test',

    // ----------------------------------------
    // AUTH - ACCEPT INVITATION
    // ----------------------------------------
    'Admin Activation': 'Activation admin',
    'Accept your invitation and secure your access.': 'Acceptez votre invitation et securisez votre acces.',
    'Complete onboarding and define your password before your first secure login.':
      'Completez l onboarding et definissez votre mot de passe avant votre premiere connexion securisee.',
    'Validate invitation': 'Valider l invitation',
    'Use the token received by email.': 'Utilisez le token recu par email.',
    'Set credentials': 'Definir les identifiants',
    'Create a password for admin access.': 'Creez un mot de passe pour l acces admin.',
    'Configure 2FA': 'Configurer la 2FA',
    'Complete Google Authenticator setup after first login.':
      'Completez la configuration Google Authenticator apres la premiere connexion.',
    'Finalize your admin setup and return to login once activation succeeds.':
      'Finalisez votre setup admin et retournez a la connexion une fois l activation reussie.',
    'Invitation token': 'Token d invitation',
    'Token received by email from a super administrator.': 'Token recu par email d un super administrateur.',
    'Activate account': 'Activer le compte',

    // ----------------------------------------
    // ADMIN ACCOUNTS
    // ----------------------------------------
    'Admin accounts and pending invitations.': 'Comptes administrateurs et invitations en attente.',
    'Invite admin': 'Inviter un admin',
    'Accounts ({{count}})': 'Comptes ({{count}})',
    'Invitations ({{count}})': 'Invitations ({{count}})',
    'Active admin accounts': 'Comptes admin actifs',
    '2FA': '2FA',
    'Activated at': 'Active le',
    'No admin account found.': 'Aucun compte administrateur.',
    '2FA enabled': 'Active',
    '2FA not configured': 'Non configure',
    'Invitation history': 'Historique des invitations',
    'Expires at': 'Expire le',
    'No invitation found.': 'Aucune invitation.',
    'Resend': 'Renvoyer',
    'Revoke': 'Revoquer',
    'Invite an administrator': 'Inviter un administrateur',
    'Email address *': 'Adresse email *',
    'Role *': 'Role *',
    'Select role': 'Selectionner un role',
    'Send invitation': 'Envoyer l invitation',

    // ----------------------------------------
    // ENGAGEMENT TASKS
    // ----------------------------------------
    'Configure the task templates that guide onboarding, contribution and repayment actions.':
      'Configurez les modeles de taches qui guident l onboarding, la contribution et le remboursement.',
    'Create task definition': 'Creer une definition de tache',
    'No tasks configured yet': 'Aucune tache configuree pour le moment',
    'Choose which tasks are created when a product or lifecycle event happens.':
      'Choisissez quelles taches sont creees lorsqu un evenement produit ou cycle de vie se produit.',
    '{{count}} task definitions configured': '{{count}} definitions de taches configurees',
    'Review the trigger, user-facing copy and action payload before publishing this task definition.':
      'Revoyez le trigger, le texte visible par l utilisateur et le payload d action avant de publier cette definition.',
    'Task title shown to users *': 'Titre de tache affiche aux utilisateurs *',
    'Example: Complete your profile': 'Exemple : Completez votre profil',
    'Short label displayed in the task card or notification surface.':
      'Libelle court affiche dans la carte de tache ou la surface de notification.',
    'Supporting description shown to users': 'Description d accompagnement affichee aux utilisateurs',
    'Explain what the user should do next.': 'Expliquez ce que l utilisateur doit faire ensuite.',
    'Explain the next step or value proposition displayed with the task.':
      'Expliquez la prochaine action ou la valeur affichee avec la tache.',
    'Set to 0 if this task does not grant any reward.':
      'Mettez 0 si cette tache ne donne aucune recompense.',
    'Visible to operators and mobile clients when enabled.':
      'Visible pour les operateurs et les clients mobiles lorsqu elle est activee.',
    'Mobile action payload (JSON) *': 'Payload action mobile (JSON) *',
    'Defines what the mobile app should open when the user taps the task.':
      'Definit ce que l application mobile doit ouvrir quand l utilisateur touche la tache.',
    'Optional metadata (JSON)': 'Metadonnees optionnelles (JSON)',
    'Use for additional settings such as base priority or targeting hints.':
      'A utiliser pour des reglages additionnels comme la priorite de base ou des indices de ciblage.',
    'Task definition created': 'Definition de tache creee',
    'Task definition updated': 'Definition de tache mise a jour',
    '{{taskType}} is now ready to be triggered.': '{{taskType}} est maintenant prete a etre declenchee.',
    'Changes saved for {{taskType}}.': 'Modifications enregistrees pour {{taskType}}.',
    'Saving task definition...': 'Enregistrement de la definition de tache...',

    // ----------------------------------------
    // PARTNERS
    // ----------------------------------------
    'Manage financial partners (IMF, banks) and operational availability per country.':
      'Gerer les partenaires financiers (IMF, banques) et la disponibilite operationnelle par pays.',
    'New partner': 'Nouveau partenaire',
    'Partner name or email': 'Nom du partenaire ou email',
    'Partner registry': 'Registre des partenaires',
    'Partner': 'Partenaire',
    'Contact': 'Contact',
    'No partner found.': 'Aucun partenaire trouve.',
    'Create partner': 'Creer un partenaire',
    'Register a financial partner and define baseline operating configuration.':
      'Enregistrer un partenaire financier et definir sa configuration de base.',
    'Legal name': 'Nom legal',
    'Partner type': 'Type de partenaire',
    'Contact email': 'Email de contact',
    'Partner details': 'Details du partenaire',
    'Review and update partner profile, status and country-level setup.':
      'Consulter et modifier le profil, statut et configuration pays du partenaire.',
    'Loading partner details...': 'Chargement des details du partenaire...',
    'Edit partner': 'Modifier le partenaire',

    // ----------------------------------------
    // OFFERS
    // ----------------------------------------
    'Create and manage financing offers with partner, country and requirement constraints.':
      'Creer et gerer les offres de financement avec contraintes partenaire, pays et exigences.',
    'New offer': 'Nouvelle offre',
    'Offer catalog': 'Catalogue des offres',
    'Range': 'Plage',
    'Rate': 'Taux',
    'Duration': 'Duree',
    'No financing offer found.': 'Aucune offre de financement trouvee.',
    'Create offer': 'Creer une offre',
    'Define pricing, limits, countries and verification requirements for a financing offer.':
      'Definir les prix, limites, pays et exigences pour une offre de financement.',
    'Title': 'Titre',
    'Min loan': 'Montant min',
    'Max loan': 'Montant max',
    'Interest rate (%)': 'Taux d interet (%)',
    'Duration (months)': 'Duree (mois)',
    'Edit offer': 'Modifier l offre',
    'Update offer parameters, country availability and requirements.':
      'Mettre a jour les parametres, disponibilite pays et exigences de l offre.',
    'Back to details': 'Retour aux details',
    'Loading offer configuration...': 'Chargement de la configuration de l offre...',
    'Save offer': 'Enregistrer l offre',
    'Offer details': 'Details de l offre',
    'Read financing terms, country coverage and requirement matrix.':
      'Consulter les termes de financement, couverture pays et matrice d exigences.',
    'Loading offer details...': 'Chargement des details de l offre...',
    'Loan range': 'Plage de pret',
    'Countries availability': 'Disponibilite pays',
    'Availability': 'Disponibilite',
    'Requirements': 'Exigences',
    'Requirement': 'Exigence',
    'Verification type': 'Type de verification',
    'Offer requirements': 'Exigences de l offre',
    'Define verification rules and required checks.': 'Definir les regles de verification et les verifications requises.',
    'Add requirement': 'Ajouter une exigence',
    'Requirement label': 'Libelle de l exigence',
    'Countries configuration': 'Configuration pays',
    'Enable/disable offer availability and configure currency by country.':
      'Activer/desactiver la disponibilite de l offre et configurer la devise par pays.',
    'Add country': 'Ajouter un pays',

    // ----------------------------------------
    // LOAN APPLICATIONS
    // ----------------------------------------
    'Loan applications': 'Demandes de pret',
    'Monitor applications by partner and status, then approve/reject with auditability.':
      'Suivre les demandes par partenaire et statut, puis approuver/rejeter avec audit.',
    'Applications queue': 'File des demandes',
    'Application ID': 'ID de demande',
    'Applicant': 'Demandeur',
    'No loan application found.': 'Aucune demande de pret trouvee.',
    'Application details': 'Details de la demande',
    'Loading application details...': 'Chargement des details de la demande...',
    'Purpose': 'Objet',
    'No purpose provided.': 'Aucun objet fourni.',
    'Reject': 'Rejeter',
    'Approve': 'Approuver',

    // ----------------------------------------
    // PARTNER REPORTING
    // ----------------------------------------
    'Partner reporting dashboard': 'Tableau de bord reporting partenaires',
    'Performance metrics for financing operations, defaults and portfolio health.':
      'Metriques de performance pour les operations de financement, defauts et sante du portefeuille.',
    'Refresh metrics': 'Actualiser les metriques',

    // ----------------------------------------
    // PARTNER USERS
    // ----------------------------------------
    'Partner users & RBAC': 'Utilisateurs partenaires et RBAC',
    'Create partner users, assign role and enforce partner-scoped access.':
      'Creer des utilisateurs partenaires, assigner des roles et gerer les acces partenaire.',
    'Full name': 'Nom complet',
    'Create partner user': 'Creer un utilisateur partenaire',
    'Filter by partner': 'Filtrer par partenaire',
    'Partner access directory': 'Annuaire d acces partenaire',
    'Partner RBAC assignments': 'Attributions RBAC partenaire',
    'No partner user found.': 'Aucun utilisateur partenaire trouve.',

    // ----------------------------------------
    // CAPITAL
    // ----------------------------------------
    'Manage capital pools and liquidity allocation per operating country.':
      'Gerer les pools de capital et l allocation de liquidites par pays d operation.',
    'New fund': 'Nouveau fonds',
    'Capital funds': 'Fonds de capital',
    'Fund': 'Fonds',
    'No capital funds found.': 'Aucun fonds de capital trouve.',
    'Create Fund': 'Creer un fonds',
    'Fund name': 'Nom du fonds',
    'Total capital': 'Capital total',
    'Save fund': 'Enregistrer le fonds',

    // ----------------------------------------
    // TREASURY
    // ----------------------------------------
    'Balance monitoring, country treasury visibility and transfer readiness.':
      'Suivi des soldes, visibilite tresorerie pays et readiness de transfert.',
    'Transfer queue': 'File de transfert',
    'Cash out requests': 'Demandes de retrait',
    'Countries monitored': 'Pays surveilles',
    'Treasury balances': 'Soldes tresorerie',
    'Transfer, cash out and balance monitoring': 'Transfert, retrait et suivi des soldes',
    'No treasury accounts found.': 'Aucun compte de tresorerie trouve.',

    // ----------------------------------------
    // LOANS
    // ----------------------------------------
    'Review, approve or reject active loan applications.':
      'Consulter, approuver ou rejeter les demandes de pret actives.',
    'Loan management': 'Gestion des prets',
    'Loan ID': 'ID pret',
    'Account Holder': 'Titulaire du compte',
    'Circle': 'Cercle',
    'No loans found.': 'Aucun pret trouve.',

    // ----------------------------------------
    // CIRCLES
    // ----------------------------------------
    'Track lifecycle, coaches and member counts of savings circles.':
      'Suivre le cycle de vie, coachs et nombre de membres des cercles d epargne.',
    'Circle portfolio': 'Portefeuille cercles',
    'Circle ID': 'ID cercle',
    'Coach': 'Coach',
    'Members': 'Membres',
    'No circles found.': 'Aucun cercle trouve.',

    // ----------------------------------------
    // AGENTS
    // ----------------------------------------
    'Operational workspace reserved for field agent supervision and onboarding controls.':
      'Espace operationnel pour la supervision et l onboarding des agents terrain.',
    'Agent management foundation': 'Base de gestion agents',
    'This feature shell is ready for agent listing, KYC review, territory assignment and activation workflows tied to `/api/admin/agent/**`.':
      'Cette zone est prete pour le listing agents, la revue KYC, l assignation territoire et les workflows d activation.',

    // ----------------------------------------
    // AUDIT
    // ----------------------------------------
    'Trace administrative activity across the operations console.':
      'Tracer l activite administrative dans la console operations.',
    'Administrative actions': 'Actions administratives',
    'Admin user': 'Utilisateur admin',
    'IP Address': 'Adresse IP',
    'No audit event found.': 'Aucun evenement d audit trouve.',

    // ----------------------------------------
    // CONFIGURATION
    // ----------------------------------------
    'Reserved for country config, operational policies and admin platform controls.':
      'Reserve pour la config pays, les politiques operationnelles et les controles admin.',
    'Security controls': 'Controles de securite',
    '2FA policy enforcement, session lifetime, invitation expiry and privileged access configuration.':
      'Application de la politique 2FA, duree de session, expiration des invitations et configuration des acces privileges.',
    'Country modules': 'Modules pays',
    'Hooks available for `countryconfig`, `progress`, `credit`, `capital` and `notifications` domain controls.':
      'Hooks disponibles pour les domaines countryconfig, progress, credit, capital et notifications.',

    // ----------------------------------------
    // MEDIA
    // ----------------------------------------
    'Search uploaded artifacts stored in MinIO and expose signed download URLs.':
      'Rechercher les artefacts stockes dans MinIO et exposer les URLs de telechargement signes.',
    'File repository': 'Depot de fichiers',
    'File': 'Fichier',
    'Owner': 'Proprietaire',
    'Uploaded at': 'Uploade le',
    'No media file found.': 'Aucun fichier media trouve.',

    // ----------------------------------------
    // NOTIFICATIONS
    // ----------------------------------------
    'Channel monitoring and template administration for SMS, email, push and in-app notifications.':
      'Surveillance des canaux et administration des templates pour SMS, email, push et notifications in-app.',
    'Notification history and template management': 'Historique des notifications et gestion des templates',
    'Feature area prepared for `/api/admin/notifications/**` integrations covering history, template versioning and retry control.':
      'Zone fonctionnelle preparee pour les integrations de notifications.',

    // ----------------------------------------
    // USERS
    // ----------------------------------------
    'Review account holders and control account access across countries.':
      'Consulter les titulaires de compte et controler les acces par pays.',
    'Admin user operations': 'Operations utilisateurs admin',
    'Account Holder ID': 'ID titulaire du compte',
    'User': 'Utilisateur',
    'Phone': 'Telephone',
    'KYC': 'KYC',
    'No users found.': 'Aucun utilisateur trouve.',
    'User profile': 'Profil utilisateur',
    'Internal profile snapshot for operations review.': 'Instantane du profil interne pour la revue des operations.',
    'Account holder ID': 'ID titulaire du compte',
    'Account status': 'Statut du compte',
    'Phone number': 'Numero de telephone',
    'KYC status': 'Statut KYC',
    'App users count': 'Nombre d utilisateurs app',

    // ----------------------------------------
    // COUNTRIES LIST
    // ----------------------------------------
    'The only entry point for country configuration.': 'Le seul point d entree pour la configuration pays.',
    'Country configuration workspace': 'Espace de travail configuration pays',
    'Select an existing country or create a new country setup.':
      'Selectionnez un pays existant ou creez un nouveau setup pays.',
    'New Country': 'Nouveau pays',
    'Loading countries...': 'Chargement des pays...',
    'Countries to configure': 'Pays a configurer',
    'Countries from world master with no configuration yet.': 'Pays du master mondial sans configuration.',
    'Start Setup': 'Demarrer le setup',
    'No countries pending first setup.': 'Aucun pays en attente de premier setup.',
    'Countries in progress': 'Pays en cours',
    'Countries with a draft or partial configuration.': 'Pays avec une configuration partielle ou brouillon.',
    'Readiness': 'Readiness',
    'Continue Setup': 'Continuer le setup',
    'No countries currently in progress.': 'Aucun pays en cours.',
    'Configured countries': 'Pays configures',
    'Countries with a validated ready configuration.': 'Pays avec une configuration validee et prete.',
    'Countries with a validated ready configuration or action required before production.':
      'Pays avec une configuration validee ou une action requise avant production.',
    'Missing:': 'Manquant :',
    'No configured countries yet.': 'Aucun pays configure.',
    'Create Country Configuration': 'Creer une configuration pays',
    'Loading available countries...': 'Chargement des pays disponibles...',
    'No countries available for configuration': 'Aucun pays disponible pour la configuration',
    'Select a country to continue.': 'Selectionnez un pays pour continuer.',

    // ----------------------------------------
    // COUNTRY DETAILS
    // ----------------------------------------
    'Loading country workspace...': 'Chargement de l espace de travail pays...',
    'Country code:': 'Code pays :',
    'This page is read-only by default and shows what is configured and what to do next.':
      'Cette page est en lecture seule par defaut et montre ce qui est configure et les prochaines etapes.',
    'Back to countries': 'Retour aux pays',
    'View Chart of Accounts': 'Voir le plan comptable',
    'Edit Configuration': 'Modifier la configuration',
    'This country is not configured yet.': 'Ce pays n est pas encore configure.',
    'Create configuration and start setup': 'Creer la configuration et demarrer le setup',
    'Country detail': 'Detail pays',
    'Read-only summary of the current section.': 'Resume en lecture seule de la section courante.',
    'Mode': 'Mode',
    'Read-only': 'Lecture seule',
    'Effective date': 'Date effective',
    'Not published yet': 'Pas encore publie',
    'Current configuration': 'Configuration actuelle',
    'This section is not configured yet.': 'Cette section n est pas encore configuree.',
    'What to do next': 'Que faire ensuite',
    'Nothing blocking this section right now.': 'Aucun point bloquant pour cette section.',
    'Country workspace unavailable.': 'Espace de travail pays indisponible.',
    'ready': 'pret',

    // ----------------------------------------
    // COMMUNITY
    // ----------------------------------------
    'Community': 'Communaute',
    'Manage publications visible in the mobile community feed.':
      'Gerer les publications visibles dans le fil communautaire mobile.',
    'New post': 'Nouveau post',
    'Publications': 'Publications',
    'Featured': 'A la une',
    'Priority': 'Priorite',
    'Likes': 'Mentions j aime',
    'Comments': 'Commentaires',
    'FEATURED': 'A LA UNE',
    'STANDARD': 'STANDARD',
    'Feature post': 'Mettre a la une',
    'Unfeature post': 'Retirer de la une',
    'No community posts found.': 'Aucune publication trouvee.',
    'Create a publication visible in the mobile community feed.':
      'Creer une publication visible dans le fil communautaire mobile.',
    'Content *': 'Contenu *',
    'Write your publication content here...': 'Redigez votre contenu ici...',
    'Media URL (optional)': 'URL media (optionnel)',
    'Publish': 'Publier',
    'Title *': 'Titre *',

    // ----------------------------------------
    // COUNTRY CONFIG (existing keys preserved)
    // ----------------------------------------
    'Structured country and platform setup with readiness checks and secure approval flow.':
      'Parametrage pays et plateforme avec controles de readiness et validation securisee.',
    'Read-only by default. Click edit to enable modifications.':
      'Lecture seule par defaut. Cliquez sur modifier pour activer les changements.',
    'Country Chart of Accounts': 'Plan comptable pays',
    'No country configured yet. Start by creating your first country configuration.':
      'Aucun pays n est configure. Commencez par creer votre premiere configuration pays.',
    'Start country setup': 'Demarrer le setup pays',
    'No countries available. Please seed or activate country master data.':
      'Aucun pays disponible. Seed ou activation des donnees master pays requis.',
    'Configured country': 'Pays configure',
    'Select configured country': 'Selectionner un pays configure',
    'Section': 'Section',
    'Current version:': 'Version actuelle :',
    'Effective date:': 'Date effective :',
    'Last modified by:': 'Derniere modification par :',
    'Mode:': 'Mode :',
    'EDIT': 'EDITION',
    'READ-ONLY': 'LECTURE SEULE',
    'Effective date for new version (optional)': 'Date effective de la nouvelle version (optionnel)',
    'Activation date (optional)': 'Date d activation (optionnel)',
    'Reload country': 'Recharger le pays',
    'Edit configuration': 'Modifier la configuration',
    'Review and save': 'Revoir et enregistrer',
    'Create new country configuration': 'Creer une nouvelle configuration pays',
    'Select unconfigured country': 'Selectionner un pays non configure',
    'All active countries are already initialized.': 'Tous les pays actifs sont deja initialises.',
    'Only editable after explicit Edit action.': 'Modifiable uniquement apres une action explicite de modification.',
    'Country Setup Wizard': 'Wizard de setup pays',
    'Guided step-by-step flow for non-technical operations users.':
      'Parcours guide pas a pas pour les equipes operations non techniques.',
    'Live wizard readiness: {{score}}%': 'Readiness du wizard en direct : {{score}}%',
    'Current step:': 'Etape actuelle :',
    'Draft auto-saved:': 'Brouillon auto-enregistre :',
    'Fix these issues before moving to the next step:':
      'Corrigez ces points avant de passer a l etape suivante :',
    'Review all sections before activation. Missing or risky sections are highlighted.':
      'Revoyez toutes les sections avant activation. Les sections manquantes ou risquees sont signalees.',
    'Findings': 'Constats',
    'No issue detected': 'Aucun point detecte',
    'Edit section': 'Modifier la section',
    'Previous': 'Precedent',
    'Save draft and continue': 'Enregistrer le brouillon et continuer',
    'Activate configuration': 'Activer la configuration',
    'Country Readiness': 'Readiness pays',
    'Checklist-driven completeness status for country operations.':
      'Statut de completude guide par checklist pour les operations pays.',
    'Configured:': 'Configure :',
    'Readiness:': 'Readiness :',
    'Loading readiness...': 'Chargement de la readiness...',
    'Progress': 'Progression',
    'Missing required items': 'Elements obligatoires manquants',
    'Complete': 'Complet',
    'No readiness data available.': 'Aucune donnee de readiness disponible.',
    'Version': 'Version',
    'Modified by': 'Modifie par',
    'Activate': 'Activer',
    'No version history for this config type.': 'Aucun historique de version pour ce type de config.',
    'Compare versions': 'Comparer les versions',
    'Left version': 'Version gauche',
    'Right version': 'Version droite',
    'Field': 'Champ',
    'Left': 'Gauche',
    'Right': 'Droite',
    'No differences to display for selected versions.':
      'Aucune difference a afficher pour les versions selectionnees.',
    'Global defaults and limits, read-only first.':
      'Parametres globaux et limites, lecture seule au depart.',
    'Global section': 'Section globale',
    'Last modified at:': 'Derniere modification le :',
    'Approved by:': 'Approuve par :',
    'Reason:': 'Raison :',
    'Platform missing checks': 'Controles plateforme manquants',
    'Secure configuration approval': 'Validation securisee de configuration',
    '1. Review': '1. Revue',
    '2. Password': '2. Mot de passe',
    '3. Reason': '3. Raison',
    '4. 2FA': '4. 2FA',
    'Review all changes before any secure validation.':
      'Revoyez tous les changements avant toute validation securisee.',
    'Before': 'Avant',
    'After': 'Apres',
    'No detected field diff. You can still continue.':
      'Aucune difference detectee. Vous pouvez quand meme continuer.',
    'Re-enter your password': 'Saisissez de nouveau votre mot de passe',
    'Enter 2FA code': 'Saisissez le code 2FA',
    'Reason for change': 'Raison du changement',
    'Next': 'Suivant',
    'Confirm save': 'Confirmer l enregistrement',
    'Reload accounts': 'Recharger les comptes',
    'Account code': 'Code compte',
    'Account name': 'Nom du compte',
    'Current balance': 'Solde courant',
    'History': 'Historique',
    'No chart account configured for this country.':
      'Aucun compte du plan comptable configure pour ce pays.',
    'Account History': 'Historique du compte',
    'Code:': 'Code :',
    'Name:': 'Nom :',
    'Opening balance:': 'Solde initial :',
    'Created at:': 'Cree le :',
    'Updated at:': 'Mis a jour le :',
    'Timestamp': 'Horodatage',
    'No movement found for this account.': 'Aucun mouvement trouve pour ce compte.',
    'Business-readable country ledger accounts with balances and transaction history.':
      'Comptes pays lisibles metier avec soldes et historique des mouvements.',
    'Select a country to initialize configuration.': 'Selectionnez un pays a initialiser.',
    'Select a configured country first.': 'Selectionnez d abord un pays configure.',
    'Select a configured country before activation.': 'Selectionnez un pays configure avant activation.',
    'Select a configured country before editing.': 'Selectionnez un pays configure avant modification.',
    'Read-only mode': 'Mode lecture seule',
    'Click "Edit configuration" before saving.': 'Cliquez sur "Modifier la configuration" avant d enregistrer.',
    'Country initialized': 'Pays initialise',
    'Country configuration initialized for {{countryCode}}.': 'Configuration pays initialisee pour {{countryCode}}.',
    'Initialization failed': 'Initialisation echouee',
    'Unable to initialize configuration for {{countryCode}}.':
      'Impossible d initialiser la configuration pour {{countryCode}}.',
    'Unable to load country configuration for {{countryCode}}.':
      'Impossible de charger la configuration pays pour {{countryCode}}.',
    'Country config saved': 'Configuration pays enregistree',
    '{{configType}} v{{version}} saved.': '{{configType}} v{{version}} enregistree.',
    'Save failed': 'Enregistrement echoue',
    'Unable to save {{configType}}.': 'Impossible d enregistrer {{configType}}.',
    'Version activated': 'Version activee',
    'Created v{{version}} from source v{{sourceVersion}}.':
      'Version v{{version}} creee depuis la source v{{sourceVersion}}.',
    'Activation failed': 'Activation echouee',
    'Unable to activate selected version.': 'Impossible d activer la version selectionnee.',
    'Wizard incomplete': 'Wizard incomplet',
    'Complete all required configuration fields before activation.':
      'Completez tous les champs obligatoires avant activation.',
    'Country setup activated': 'Setup pays active',
    'Activated {{count}} configuration sections for {{countryCode}}.':
      '{{count}} sections de configuration activees pour {{countryCode}}.',
    'Unable to activate the full country setup.':
      'Impossible d activer l ensemble du setup pays.',
    'Platform config saved': 'Configuration plateforme enregistree',
    'Step 1: General': 'Etape 1 : General',
    'Confirm country and currency before configuration.':
      'Confirmez le pays et la devise avant configuration.',
    'Step 2: Accounting': 'Etape 2 : Comptabilite',
    'Map required accounting accounts.': 'Mappez les comptes comptables obligatoires.',
    'Step 3: Membership': 'Etape 3 : Adhesion',
    'Configure membership plans and pricing.': 'Configurez les plans d adhesion et les tarifs.',
    'Step 4: MLM & Gains': 'Etape 4 : MLM et gains',
    'Configure caps, rates and fallback rules.':
      'Configurez les caps, les taux et les regles de fallback.',
    'Step 5: Financing': 'Etape 5 : Financement',
    'Select enabled and seed capital financing offers.':
      'Selectionnez les offres de financement actives et seed capital.',
    'Step 6: Payment': 'Etape 6 : Paiement',
    'Configure payment methods and active PSPs.':
      'Configurez les methodes de paiement et les PSP actifs.',
    'Step 6: Risk & Guarantee': 'Etape 6 : Risque et garantie',
    'Step 7: Risk & Guarantee': 'Etape 7 : Risque et garantie',
    'Set guarantee and risk limits by tier.': 'Definissez les limites de garantie et de risque par tier.',
    'Step 7: Review & Activate': 'Etape 7 : Revue et activation',
    'Step 8: Review & Activate': 'Etape 8 : Revue et activation',
    'Review all sections, fix issues, then activate securely.':
      'Revoyez toutes les sections, corrigez les points puis activez de facon securisee.',
    'Allocation': 'Allocation',
    'Tax rate (%)': 'Taux de taxe (%)',
    'Marketplace default commission (%)': 'Commission marketplace par defaut (%)',
    'Min circle members': 'Membres minimum par cercle',
    'Max circle members': 'Membres maximum par cercle',
    'Max assisted members': 'Membres assistes maximum',
    'Chat enabled': 'Chat active',
    'Marketplace enabled': 'Marketplace activee',
    'Financing enabled': 'Financement active',
    'Loan enabled': 'Pret active',
    'Classic plan': 'Plan Classic',
    'Gold plan': 'Plan Gold',
    'Diamond plan': 'Plan Diamond',
    'Price': 'Prix',
    'Benefits (comma separated)': 'Benefices (separes par des virgules)',
    'Max direct children': 'Nombre max de filleuls directs',
    'Global weekly cap': 'Plafond hebdomadaire global',
    'Classic weekly cap': 'Plafond hebdomadaire Classic',
    'Gold weekly cap': 'Plafond hebdomadaire Gold',
    'Diamond weekly cap': 'Plafond hebdomadaire Diamond',
    'Global MLM configuration (read-only)': 'Configuration MLM globale (lecture seule)',
    'MLM rates are managed globally at platform level and apply to all countries.':
      'Les taux MLM sont geres globalement au niveau plateforme et s appliquent a tous les pays.',
    'Binary matching rule': 'Regle de matching binaire',
    'Binary percentage (%)': 'Pourcentage binaire (%)',
    'Weaker leg': 'Jambe faible',
    'Generation {{generation}} unilevel (%)': 'Generation {{generation}} unilevel (%)',
    'Global max exposure': 'Exposition maximale globale',
    'Classic max amount': 'Montant maximum Classic',
    'Gold max amount': 'Montant maximum Gold',
    'Diamond max amount': 'Montant maximum Diamond',
    'Classic risk limit': 'Limite de risque Classic',
    'Gold risk limit': 'Limite de risque Gold',
    'Diamond risk limit': 'Limite de risque Diamond',
    'Seed capital required': 'Seed capital requis',
    'Min amount': 'Montant minimum',
    'Max amount': 'Montant maximum',
    'Max interest rate (%)': 'Taux d interet maximum (%)',
    'Enabled financing offer': 'Offre de financement active',
    'Select offer': 'Selectionner une offre',
    'Seed capital offer': 'Offre seed capital',
    'Select seed offer': 'Selectionner une offre seed',
    'IMF product mapping': 'Mapping produits IMF',
    'Map each active IMF to the required business products.':
      'Associer chaque IMF active aux produits metier obligatoires.',
    'IMF partner': 'IMF partenaire',
    'Member savings product': 'Produit Epargne membre',
    'Seed capital product': 'Produit Seed Capital',
    'Business capital product': 'Produit Business Capital',
    'Account opening fee product': 'Produit Frais ouverture',
    'Product purpose is not compatible with product type.':
      'Le besoin produit n est pas compatible avec le type de produit.',
    'Create an IMF business product for operations mapping.':
      'Creer un produit metier IMF pour le mapping operationnel.',
    'Update an IMF business product used by operations mapping.':
      'Modifier un produit metier IMF utilise par le mapping operationnel.',
    'Review the IMF business product used by operations mapping.':
      'Consulter le produit metier IMF utilise par le mapping operationnel.',
    'Advanced mode': 'Mode avance',
    'Hide advanced mode': 'Masquer le mode avance',
    'Advanced technical settings for developers only.':
      'Parametres techniques avances reserves aux developpeurs.',
    'No active IMF partner for this country.': 'Aucune IMF active pour ce pays.',
    'Guarantee pool account': 'Compte pool garantie',
    'Admin pool account': 'Compte pool admin',
    'Platform pool account': 'Compte pool plateforme',
    'Commission pool account': 'Compte pool commission',
    'Social fund account': 'Compte fonds social',
    'Loan disbursement account': 'Compte de decaissement pret',
    'Fees account': 'Compte frais',
    'Reserves account': 'Compte reserves',
    'Penalties account': 'Compte penalites',
    'Select account': 'Selectionner un compte',
    'Payment enabled': 'Paiement active',
    'Settlement window (hours)': 'Fenetre de settlement (heures)',
    'Fee rate (0 to 1)': 'Taux de frais (0 a 1)',
    'Allowed methods (csv)': 'Methodes autorisees (csv)',
    'Active PSP': 'PSP actif',
    'Select active PSP': 'Selectionner le PSP actif',
    'Unilevel base rate (%)': 'Taux de base unilevel (%)',
    'Binary base rate (%)': 'Taux de base binaire (%)',
    'Operations %': 'Operations %',
    'Reserves %': 'Reserves %',
    'MLM %': 'MLM %',
    'Treasury %': 'Tresorerie %',
    'Country:': 'Pays :',
    'Currency:': 'Devise :',
    'Classic': 'Classic',
    'Gold': 'Gold',
    'Diamond': 'Diamond',
    'Free': 'Gratuit',
    'Free plan': 'Plan gratuit',
    'Total price': 'Prix total',
    'Monthly price': 'Prix mensuel',
    'Included': 'Inclus',
    '{{duration}} month(s)': '{{duration}} mois',
    'Edit the total price for each duration. Monthly price is calculated automatically, and FREE stays fixed at 0.':
      'Editez le prix total pour chaque duree. Le prix mensuel est calcule automatiquement et le plan GRATUIT reste fixe a 0.',
    '{{section}}.country is required.': '{{section}}.le pays est obligatoire.',
    '{{section}}.currency must be a valid 3-letter code.':
      '{{section}}.la devise doit etre un code valide sur 3 lettres.',
    '{{section}}.tax rate must be between 0 and 100%.':
      '{{section}}.le taux de taxe doit etre compris entre 0 et 100 %.',
    '{{section}}.marketplace commission must be between 0 and 100%.':
      '{{section}}.la commission marketplace doit etre comprise entre 0 et 100 %.',
    '{{section}}.min circle members must be >= 1.':
      '{{section}}.le nombre minimum de membres du cercle doit etre >= 1.',
    '{{section}}.max circle members must be >= 1.':
      '{{section}}.le nombre maximum de membres du cercle doit etre >= 1.',
    '{{section}}.max circle members must be greater than or equal to min circle members.':
      '{{section}}.le nombre maximum de membres du cercle doit etre superieur ou egal au minimum.',
    '{{section}}.max assisted members must be >= 0.':
      '{{section}}.le nombre maximum de membres assistes doit etre >= 0.',
    '{{section}}.{{label}} is required.': '{{section}}.{{label}} est obligatoire.',
    '{{section}}.automation mode is required.': '{{section}}.le mode d automatisation est obligatoire.',
    '{{section}}.master template is required.': '{{section}}.le modele maitre est obligatoire.',
    '{{section}}.required system tags must not be empty.':
      '{{section}}.les tags systeme obligatoires ne doivent pas etre vides.',
    '{{section}}.unsupported accounting tag: {{tag}}.':
      '{{section}}.tag comptable non supporte : {{tag}}.',
    '{{section}} must define 10 plans: 9 paid variants and 1 free plan.':
      '{{section}} doit definir 10 plans : 9 variantes payantes et 1 plan gratuit.',
    '{{section}}.formulaType is required for every plan.':
      '{{section}}.formulaType est obligatoire pour chaque plan.',
    '{{section}}.durationMonths is required for every plan.':
      '{{section}}.durationMonths est obligatoire pour chaque plan.',
    '{{section}} contains duplicate formula/duration combinations.':
      '{{section}} contient des combinaisons formule/duree en double.',
    '{{section}}.FREE plan must use durationMonths = 1.':
      '{{section}}.le plan GRATUIT doit utiliser durationMonths = 1.',
    '{{section}}.FREE plan total price must be 0.':
      '{{section}}.le prix total du plan GRATUIT doit etre 0.',
    '{{section}}.paid plan durations must be 1, 3 or 12 months only.':
      '{{section}}.les durees payantes doivent etre 1, 3 ou 12 mois uniquement.',
    '{{section}}.{{formula}} {{duration}}-month total price must be positive.':
      '{{section}}.le prix total {{formula}} sur {{duration}} mois doit etre positif.',
    '{{section}}.{{formula}} must define 1, 3 and 12-month variants.':
      '{{section}}.{{formula}} doit definir les variantes 1, 3 et 12 mois.',
    '{{section}} must include exactly one FREE plan.':
      '{{section}} doit inclure exactement un plan GRATUIT.',
    '{{section}}.max direct children must be >= 1.':
      '{{section}}.le nombre maximum d enfants directs doit etre >= 1.',
    '{{section}}.{{label}} must be >= 0.': '{{section}}.{{label}} doit etre >= 0.',
    '{{section}}.Global weekly cap must be >= 0.':
      '{{section}}.le plafond hebdomadaire global doit etre >= 0.',
    '{{section}}.unilevel rate must be between 0 and 100%.':
      '{{section}}.le taux unilevel doit etre compris entre 0 et 100 %.',
    '{{section}}.binary rate must be between 0 and 100%.':
      '{{section}}.le taux binaire doit etre compris entre 0 et 100 %.',
    '{{section}}.unilevel rate must be <= 100%.': '{{section}}.le taux unilevel doit etre <= 100%.',
    '{{section}}.binary rate must be <= 100%.': '{{section}}.le taux binaire doit etre <= 100%.',
    '{{section}}.enabled offer is required when financing is enabled.':
      '{{section}}.une offre active est obligatoire quand le financement est active.',
    '{{section}}.seed capital offer is required.': '{{section}}.une offre seed capital est obligatoire.',
    '{{section}}.min amount must be >= 0.': '{{section}}.le montant min doit etre >= 0.',
    '{{section}}.max amount must be >= 0.': '{{section}}.le montant max doit etre >= 0.',
    '{{section}}.max amount must be greater than or equal to min amount.':
      '{{section}}.le montant max doit etre superieur ou egal au montant min.',
    '{{section}}.max interest rate must be between 0 and 100%.':
      '{{section}}.le taux d interet max doit etre compris entre 0 et 100 %.',
    '{{section}}.active PSP is required when payment is enabled.':
      '{{section}}.un PSP actif est obligatoire quand le paiement est active.',
    '{{section}}.methods must include at least one method.':
      '{{section}}.les methodes doivent inclure au moins une methode.',
    '{{section}}.global max exposure must be >= 0.':
      '{{section}}.l exposition maximale globale doit etre >= 0.',
    '{{section}}.{{tier}} max amount must be positive.':
      '{{section}}.le montant max {{tier}} doit etre positif.',
    '{{section}}.{{tier}} risk limit must be >= 0.':
      '{{section}}.la limite de risque {{tier}} doit etre >= 0.',
    'MLM caps must align with membership tiers':
      'Les plafonds MLM doivent etre alignes avec les niveaux d adhesion.',
    'Custom MLM rate overrides are not allowed. Use the global MLM configuration.':
      'Les overrides de taux MLM ne sont pas autorises. Utilisez la configuration MLM globale.',
    'Guarantee configuration must align with membership tiers':
      'La configuration des garanties doit etre alignee avec les niveaux d adhesion.',
    'Guarantee must align with financing rules':
      'La garantie doit etre coherente avec les regles de financement.',
    'Guarantee maxAmount must be <= financing maxAmount':
      'Le montant max de garantie doit etre <= au montant max de financement.',
    'Guarantee maxExposure must be <= financing maxAmount':
      'L exposition max de garantie doit etre <= au montant max de financement.',
    'Configuration invalid': 'Configuration invalide',
    'Validation failed': 'Validation echouee',
    'Unable to validate the full country setup right now.':
      'Impossible de valider le setup pays complet pour le moment.',
    'Review all sections before activation. Resolve blocking issues first.':
      'Revoyez toutes les sections avant activation et corrigez les points bloquants.',
    'High unilevel rate (>= 40%).': 'Taux unilevel eleve (>= 40%).',
    'High binary rate (>= 30%).': 'Taux binaire eleve (>= 30%).',
    'High max interest rate (>= 35%).': 'Taux d interet max eleve (>= 35%).',
    'High payment fee rate (>= 5%).': 'Taux de frais paiement eleve (>= 5%).',
    'READY': 'PRET',
    'PARTIAL': 'PARTIEL',
    'DRAFT': 'BROUILLON',
    'ACTIVE': 'ACTIF',
    'INACTIVE': 'INACTIF',
    'COMPLETE': 'COMPLET',
    'MISSING': 'MANQUANT',
    'RISKY': 'RISQUE',

    // ----------------------------------------
    // CHART OF ACCOUNTS
    // ----------------------------------------
    'Generate Standard Accounts': 'Generer les comptes standards',
    '+ Create Account': '+ Creer un compte',
    'Group': 'Groupe',
    'Label': 'Libelle',
    'Ex: Commission Pool Benin': 'Ex: Pool Commission Benin',
    'Create Account': 'Creer le compte',
    'Account number': 'Numero de compte',
    'Number:': 'Numero :',
    'Account holder:': 'Titulaire du compte :',
    'Current balance:': 'Solde courant :',
    'USER_WALLET': 'PORTEFEUILLE',
    'Holder ID': 'ID titulaire',
    'Effective date for activation (optional)': 'Date d activation effective (optionnel)',

    // ----------------------------------------
    // COMMERCE R1 : MARCHANDS, MARCHES, PRODUITS, COMMANDES
    // ----------------------------------------
    'This field is required.': 'Ce champ est obligatoire.',
    'Enter a valid email address.': 'Saisissez une adresse e-mail valide.',
    'Invalid value.': 'Valeur invalide.',
    'The value must be zero or greater.': 'La valeur doit etre positive ou nulle.',
    'The value must be greater than zero.': 'La valeur doit etre superieure a zero.',
    'Use a 3-letter currency code.': 'Utilisez un code devise de 3 lettres.',
    'Complete the highlighted fields.': 'Completez les champs signales.',
    'Merchant not saved': 'Marchand non enregistre',
    'Product not saved': 'Produit non enregistre',
    'Merchant country': 'Pays du marchand',
    'Select the merchant country': 'Choisissez le pays du marchand',
    'Must stay the country of the merchant account holder.': 'Doit rester le pays du titulaire du marchand.',
    'The account holder of an existing merchant cannot be changed.': 'Le titulaire d un marchand existant ne peut pas changer.',
    'Select the merchant country first: only account holders of that country are listed.': 'Choisissez d abord le pays du marchand : seuls les titulaires de ce pays sont proposes.',
    'No active account holder has this country.': 'Aucun titulaire actif n a ce pays.',
    'Only account holders whose country is {{country}} are listed.': 'Seuls les titulaires dont le pays est {{country}} sont proposes.',
    'Unable to load the account holders of this country.': 'Impossible de charger les titulaires de ce pays.',
    'already a merchant': 'deja marchand',
    'The merchant country must be the country of its account holder.': 'Le pays du marchand doit etre celui de son titulaire.',
    'This account holder has no country, so it cannot back a merchant.': 'Ce titulaire n a pas de pays : il ne peut pas porter un marchand.',
    'Register this merchant on the Merchants page before adding products.': 'Enregistrez ce marchand dans la page Marchands avant d ajouter des produits.',
    'Only an active registered merchant can create products.': 'Seul un marchand enregistre et actif peut creer des produits.',
    'A digital product needs a fulfillment provider and an external course ID.': 'Un produit numerique exige un fournisseur de livraison et un identifiant de cours externe.',
    'A physical product cannot have a fulfillment provider or an external course ID.': 'Un produit physique ne peut pas avoir de fournisseur de livraison ni d identifiant de cours externe.',
    'A digital product is sold in XOF.': 'Un produit numerique se vend en XOF.',
    'Market': 'Marche',
    'All markets': 'Tous les marches',
    'Unable to load the commerce markets.': 'Impossible de charger les marches commerce.',
    'inactive': 'inactif',
    'Merchant not registered': 'Marchand non enregistre',
    'Select a registered merchant': 'Choisissez un marchand enregistre',
    'Select a merchant': 'Choisissez un marchand',
    'No registered merchant yet: create one on the Merchants page first.': 'Aucun marchand enregistre : creez-en un dans la page Marchands.',
    'A product is sold in the market of its merchant.': 'Un produit se vend dans le marche de son marchand.',
    'Only an active product is sold in the Store.': 'Seul un produit actif est vendu dans la Boutique.',
    'Seller': 'Vendeur',
    'Buyer': 'Acheteur',
    'Parties': 'Intervenants',
    'Seller code': 'Code vendeur',
    'Seller code / DSB': 'Code vendeur / DSB',
    'No seller': 'Aucun vendeur',
    'No seller code': 'Aucun code vendeur',
    'Unavailable': 'Non disponible',
    'Name unavailable': 'Nom non disponible',
    'Delivered at': 'Livree le',
    'Settled at': 'Reglee le',
    'Not delivered': 'Non livree',
    'Not settled': 'Non reglee',
    'No item recorded for this order.': 'Aucun article enregistre pour cette commande.',
  },
};
